import { createFileRoute, redirect } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';
import { Header } from '../components/layout/Header';
import { MessagesView } from '../components/chat/MessagesView';

export const Route = createFileRoute('/messages')({
  validateSearch: (
    search: Record<string, unknown>,
  ): { conversationUuid?: string; offerUuid?: string } => {
    return {
      conversationUuid: (search.conversationUuid as string) || undefined,
      offerUuid: typeof search.offerUuid === 'string' ? search.offerUuid : undefined,
    };
  },
  beforeLoad: ({ location }) => {
    if (!localStorage.getItem('access_token')) {
      throw redirect({ to: '/sign-in', search: { redirect: location.pathname } });
    }
  },
  component: MessagesPage,
});

function MessagesPage() {
  const { conversationUuid, offerUuid } = Route.useSearch();

  return (
    <div className="h-screen bg-black text-white flex flex-col overflow-hidden">
      <Helmet>
        <title>Inbox | Musicade</title>
        <meta
          name="description"
          content="Your inbox, direct messaging and conversations on Musicade."
        />
      </Helmet>

      <Header />

      <main className="flex-1 flex flex-col p-2 sm:p-4 pt-[calc(var(--header-height,5.5rem)+0.5rem)] sm:pt-[calc(var(--header-height,5.5rem)+0.75rem)] overflow-hidden w-full">
        <MessagesView initialConversationUuid={conversationUuid} highlightOfferUuid={offerUuid} />
      </main>
    </div>
  );
}
